import React from 'react';
import { Navbar, Nav, Container, Badge } from 'react-bootstrap';

export default function Header(){
  return (
    <Navbar expand="lg" sticky="top" className="shadow navbar-single-row" style={{ background: 'linear-gradient(135deg, #1a3a44, #2d5a6f)' }}>
      <Container fluid>
          <Navbar.Brand href="#home" className="d-flex align-items-center gap-2 fw-bold text-light" onClick={(e) => {
            e.preventDefault();
            try { window.history.replaceState({}, '', '/'); } catch {};
            try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch {};
            setTimeout(() => { window.location.reload(); }, 120);
          }}>
          <img src="/nbf_logo_ref.svg" width={50} alt="Northwest Bible Fellowship logo" className="navbar-logo" />
          <span>Northwest Bible Fellowship</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-auto navbar-toggle-sm" style={{ borderColor: 'rgba(197, 54, 7, 0.96)', backgroundColor: 'rgba(197, 54, 7, 0.96)' }} />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="ms-auto gap-2">
            <Nav.Link href="#home" className="text-light fw-semibold">Home</Nav.Link>
            <Nav.Link href="#about" className="text-light fw-semibold">About</Nav.Link>
            <Nav.Link href="#meetings" className="text-light fw-semibold">Meetings</Nav.Link>
            <Nav.Link href="#events" className="text-light fw-semibold">Events</Nav.Link>
            <Nav.Link href="#sermons" className="text-light fw-semibold">Sermons</Nav.Link>
            <Nav.Link href="#contact" className="text-light fw-semibold">Contact</Nav.Link>
            <Nav.Link href="#donate" className="text-light fw-semibold ms-2">
              <Badge bg="warning" text="dark" className="fw-bold">Give</Badge>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}